<h3>Configuração do Formulário Pós-Checkout</h3>
<form class="form-b4a p-card" [formGroup]="form">
  <span class="p-float-label">
    <input
      type="text"
      pInputText
      formControlName="mainText"
      id="mainText"
      name="mainText"
    />
    <label for="mainText">Texto principal *</label>
  </span>
  <span class="p-float-label">
    <input
      type="text"
      pInputText
      formControlName="secondaryText"
      id="secondaryText"
      name="secondaryText"
    />
    <label for="secondaryText">Texto secundário *</label>
  </span>
  <span class="p-float-label">
    <input
      type="text"
      pInputText
      formControlName="link"
      id="link"
      name="link"
    />
    <label for="link">Link *</label>
  </span>
  <span class="p-input-checkbox">
    <p-checkbox formControlName="active" [binary]="true" inputId="active" />
    <label for="active">Ativo</label>
  </span>
</form>
<p-button label="Salvar" [disabled]="!form?.valid" (onClick)="submit()" />
